import PropTypes from 'prop-types';

export default PropTypes.shape({
  currencies: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string
    })
  ),
  productFamilies: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string
    })
  ),
  productFamiliesAccessibleTravel: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string
    })
  ),
  paymentLocation: PropTypes.shape({
    name: PropTypes.string
  }),
  salesChannel: PropTypes.string,
  canOverrideFees: PropTypes.bool,
  canOverrideRules: PropTypes.bool,
  fullName: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  canEditPassengers: PropTypes.bool,
  canHaveGroupBookings: PropTypes.bool,
  canHaveStandardBookings: PropTypes.bool,
  canHaveAccessibleTravelBookings: PropTypes.bool,
  isStation: PropTypes.bool
});
